// Country → Currency mapping
const COUNTRY_CURRENCY = {
  'India': { symbol: '₹', code: 'INR' },
  'United States': { symbol: '$', code: 'USD' },
  'United Kingdom': { symbol: '£', code: 'GBP' },
  'Canada': { symbol: 'C$', code: 'CAD' },
  'Australia': { symbol: 'A$', code: 'AUD' },
  'Germany': { symbol: '€', code: 'EUR' },
  'France': { symbol: '€', code: 'EUR' },
  'Italy': { symbol: '€', code: 'EUR' },
  'Spain': { symbol: '€', code: 'EUR' },
  'Netherlands': { symbol: '€', code: 'EUR' },
  'Belgium': { symbol: '€', code: 'EUR' },
  'Austria': { symbol: '€', code: 'EUR' },
  'Ireland': { symbol: '€', code: 'EUR' },
  'Portugal': { symbol: '€', code: 'EUR' },
  'Finland': { symbol: '€', code: 'EUR' },
  'Greece': { symbol: '€', code: 'EUR' },
  'Japan': { symbol: '¥', code: 'JPY' },
  'China': { symbol: '¥', code: 'CNY' },
  'South Korea': { symbol: '₩', code: 'KRW' },
  'Brazil': { symbol: 'R$', code: 'BRL' },
  'Mexico': { symbol: 'MX$', code: 'MXN' },
  'Russia': { symbol: '₽', code: 'RUB' },
  'South Africa': { symbol: 'R', code: 'ZAR' },
  'Saudi Arabia': { symbol: 'SAR', code: 'SAR' },
  'UAE': { symbol: 'AED', code: 'AED' },
  'United Arab Emirates': { symbol: 'AED', code: 'AED' },
  'Singapore': { symbol: 'S$', code: 'SGD' },
  'Malaysia': { symbol: 'RM', code: 'MYR' },
  'Thailand': { symbol: '฿', code: 'THB' },
  'Indonesia': { symbol: 'Rp', code: 'IDR' },
  'Philippines': { symbol: '₱', code: 'PHP' },
  'Vietnam': { symbol: '₫', code: 'VND' },
  'Turkey': { symbol: '₺', code: 'TRY' },
  'Switzerland': { symbol: 'CHF', code: 'CHF' },
  'Sweden': { symbol: 'kr', code: 'SEK' },
  'Norway': { symbol: 'kr', code: 'NOK' },
  'Denmark': { symbol: 'kr', code: 'DKK' },
  'Poland': { symbol: 'zł', code: 'PLN' },
  'Nigeria': { symbol: '₦', code: 'NGN' },
  'Kenya': { symbol: 'KSh', code: 'KES' },
  'Egypt': { symbol: 'E£', code: 'EGP' },
  'Pakistan': { symbol: '₨', code: 'PKR' },
  'Bangladesh': { symbol: '৳', code: 'BDT' },
  'Sri Lanka': { symbol: 'Rs', code: 'LKR' },
  'Nepal': { symbol: 'रू', code: 'NPR' },
  'New Zealand': { symbol: 'NZ$', code: 'NZD' },
  'Argentina': { symbol: 'AR$', code: 'ARS' },
  'Colombia': { symbol: 'CO$', code: 'COP' },
  'Chile': { symbol: 'CL$', code: 'CLP' },
  'Peru': { symbol: 'S/', code: 'PEN' },
  'Israel': { symbol: '₪', code: 'ILS' },
  'Qatar': { symbol: 'QAR', code: 'QAR' },
  'Kuwait': { symbol: 'KD', code: 'KWD' },
  'Bahrain': { symbol: 'BD', code: 'BHD' },
  'Oman': { symbol: 'OMR', code: 'OMR' },
};

const DEFAULT_CURRENCY = { symbol: '₹', code: 'INR' };

export const getCurrency = (country) => {
  if (!country) return DEFAULT_CURRENCY;
  return COUNTRY_CURRENCY[country] || DEFAULT_CURRENCY;
};

export const formatPrice = (amount, country) => {
  const { symbol } = getCurrency(country);
  const num = Number(amount);
  if (isNaN(num)) return `${symbol}0`;
  return `${symbol}${num.toLocaleString()}`;
};

export const getCurrencyCode = (country) => getCurrency(country).code;
export const getCurrencySymbol = (country) => getCurrency(country).symbol;

// Popular currencies for the dropdown
export const CURRENCY_OPTIONS = [
  { code: 'INR', symbol: '₹', label: 'INR (₹) - Indian Rupee' },
  { code: 'USD', symbol: '$', label: 'USD ($) - US Dollar' },
  { code: 'GBP', symbol: '£', label: 'GBP (£) - British Pound' },
  { code: 'EUR', symbol: '€', label: 'EUR (€) - Euro' },
  { code: 'AED', symbol: 'AED', label: 'AED - UAE Dirham' },
  { code: 'SAR', symbol: 'SAR', label: 'SAR - Saudi Riyal' },
  { code: 'CAD', symbol: 'C$', label: 'CAD (C$) - Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', label: 'AUD (A$) - Australian Dollar' },
  { code: 'SGD', symbol: 'S$', label: 'SGD (S$) - Singapore Dollar' },
  { code: 'JPY', symbol: '¥', label: 'JPY (¥) - Japanese Yen' },
  { code: 'CNY', symbol: '¥', label: 'CNY (¥) - Chinese Yuan' },
  { code: 'KRW', symbol: '₩', label: 'KRW (₩) - Korean Won' },
  { code: 'MYR', symbol: 'RM', label: 'MYR (RM) - Malaysian Ringgit' },
  { code: 'THB', symbol: '฿', label: 'THB (฿) - Thai Baht' },
  { code: 'BRL', symbol: 'R$', label: 'BRL (R$) - Brazilian Real' },
  { code: 'ZAR', symbol: 'R', label: 'ZAR (R) - South African Rand' },
  { code: 'TRY', symbol: '₺', label: 'TRY (₺) - Turkish Lira' },
  { code: 'CHF', symbol: 'CHF', label: 'CHF - Swiss Franc' },
  { code: 'SEK', symbol: 'kr', label: 'SEK (kr) - Swedish Krona' },
  { code: 'NGN', symbol: '₦', label: 'NGN (₦) - Nigerian Naira' },
  { code: 'PKR', symbol: '₨', label: 'PKR (₨) - Pakistani Rupee' },
  { code: 'BDT', symbol: '৳', label: 'BDT (৳) - Bangladeshi Taka' },
  { code: 'QAR', symbol: 'QAR', label: 'QAR - Qatari Riyal' },
  { code: 'KWD', symbol: 'KD', label: 'KWD (KD) - Kuwaiti Dinar' },
  { code: 'NZD', symbol: 'NZ$', label: 'NZD (NZ$) - New Zealand Dollar' },
];

// Get symbol from currency code directly
export const getSymbolByCode = (code) => {
  if (!code) return DEFAULT_CURRENCY.symbol;
  const opt = CURRENCY_OPTIONS.find(c => c.code === code);
  if (opt) return opt.symbol;
  // Fallback: find from country map
  for (const [, cur] of Object.entries(COUNTRY_CURRENCY)) {
    if (cur.code === code) return cur.symbol;
  }
  return code;
};

// Get symbol - accepts either a currency code or country name
export const getSymbol = (currencyOrCountry) => {
  if (!currencyOrCountry) return DEFAULT_CURRENCY.symbol;
  // Check if it's a currency code first (uppercase, 3 chars)
  const opt = CURRENCY_OPTIONS.find(c => c.code === currencyOrCountry);
  if (opt) return opt.symbol;
  // Check country map
  return getCurrency(currencyOrCountry).symbol;
};

export default COUNTRY_CURRENCY;
